module.exports = __webpack_public_path__ + "img/lead-04e.470d0bae.png";